module.exports = "/_next/static/images/software-development-banner-mobile-d2a51f0cc48dcea3acb85f0880e3c321.webp";